import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';

const ErrorPopup = ({ error, errorInfo, onDismiss, onReset }) => {
    const navigate = useNavigate();

    const handleClose = () => {
        onDismiss();
        navigate(-1);
    };

    const errorCode = error?.code || 500;
    let IconComponent = null;
    let titleStyle = { padding: '1em' };
    let buttonColor = '#ED5565'; // default error red

    if (String(errorCode).startsWith('4')) {
        buttonColor = '#ffbf00'; // warning yellow
        titleStyle = {
            backgroundColor: '#ffbf00',
            height: '2em',
            padding: '0.3em',
            color: 'white'
        };
        IconComponent = WarningIcon;
    } else if (String(errorCode).startsWith('5')) {
        titleStyle = {
            backgroundColor: '#ED5565',
            height: '2em',
            padding: '0.3em',
            color: 'white'
        };
        IconComponent = ErrorIcon;
    }

    return (
        <Dialog
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    handleClose();
                }
            }}
            // eslint-disable-next-line react/jsx-boolean-value
            open={true}
            
            PaperProps={{
                style: {
                    backgroundColor: "white",
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)', // Added shadow
                    width: '25%',
                    maxWidth: 'none',
                    height: 'auto',
                    maxHeight: '80vh',
                },
            }}
            BackdropProps={{
                style: {
                    backgroundColor: 'transparent',
                },
            }}
        >
            <DialogTitle style={titleStyle}>
                {IconComponent && (
                    <IconComponent style={{ verticalAlign: 'middle', marginRight: '0.5em' }} />
                )}
                {String(errorCode).startsWith('5') ? 'Error' : 'Warning'}
            </DialogTitle>
            <DialogContent style={{ padding: '1em', overflow: 'hidden' }}>
                <DialogContentText style={{
                    textAlign: "center",
                    whiteSpace: 'pre-wrap',
                    overflow: 'hidden',
                    wordBreak: 'break-word'
                }}>
                    Unable to complete this process. Please try again.
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button
                    variant='contained'
                    sx={{
                        minWidth: '1em',
                        minHeight: '0.5em',
                        padding: '4px 7px 4px 7px',
                        backgroundColor: buttonColor,
                        color: 'white',
                        '&:hover': {
                            backgroundColor: buttonColor,
                        },
                    }}
                    onClick={handleClose}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ErrorPopup.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
        code: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    errorInfo: PropTypes.shape({
        componentStack: PropTypes.string,
    }),
    onDismiss: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
};

export default ErrorPopup;
